import { HookType } from './hook';
import {
  AnnotationContentAction,
  AnnotationStatusAction,
  EmailAction,
  InvocationAction,
  UploadAction,
} from './hookUtils';
import { LogLevel } from './runLog';

export const STATUS_CODE_2XX_OPTIONS = [
  '200',
  '201',
  '202',
  '203',
  '204',
  '205',
  '206',
  '207',
  '208',
  '226',
] as const;

export const STATUS_CODE_4XX_OPTIONS = [
  '400',
  '401',
  '402',
  '403',
  '404',
  '405',
  '406',
  '407',
  '408',
  '409',
  '410',
  '411',
  '412',
  '413',
  '414',
  '415',
  '416',
  '417',
  '418',
  '421',
  '422',
  '423',
  '424',
  '425',
  '426',
  '428',
  '429',
  '431',
  '451',
] as const;

export const STATUS_CODE_5XX_OPTIONS = [
  '500',
  '501',
  '502',
  '503',
  '504',
  '505',
  '506',
  '507',
  '508',
  '510',
  '511',
] as const;

export const STATUS_CODE_OPTIONS = [
  ...STATUS_CODE_2XX_OPTIONS,
  ...STATUS_CODE_4XX_OPTIONS,
  ...STATUS_CODE_5XX_OPTIONS,
] as const;

// using (typeof STATUS_CODE_OPTIONS)[number] throws error when using ts-to-zod generator
export type StatusCode =
  | '200'
  | '201'
  | '202'
  | '203'
  | '204'
  | '205'
  | '206'
  | '207'
  | '208'
  | '226'
  | '400'
  | '401'
  | '402'
  | '403'
  | '404'
  | '405'
  | '406'
  | '407'
  | '408'
  | '409'
  | '410'
  | '411'
  | '412'
  | '413'
  | '414'
  | '415'
  | '416'
  | '417'
  | '418'
  | '421'
  | '422'
  | '423'
  | '424'
  | '425'
  | '426'
  | '428'
  | '429'
  | '431'
  | '451'
  | '500'
  | '501'
  | '502'
  | '503'
  | '504'
  | '505'
  | '506'
  | '507'
  | '508'
  | '510'
  | '511';

export type RunStatus =
  | 'completed'
  | 'failed'
  | 'running'
  | 'cancelled'
  | 'waiting';

export const RUN_STATUS_OPTIONS = [
  'completed',
  'failed',
  'running',
  'cancelled',
  'waiting',
] as const satisfies RunStatus[];

type AnnotationContentRun = RunBase & {
  annotationId?: number | null;
  event: 'annotation_content';
  action: AnnotationContentAction;
};

type AnnotationStatusRun = RunBase & {
  annotationId?: number | null;
  event: 'annotation_status';
  action: AnnotationStatusAction;
};

type UploadRun = RunBase & {
  emailId?: number | null;
  event: 'upload';
  action: UploadAction;
};

type EmailRun = RunBase & {
  emailId?: number | null;
  event: 'email';
  action: EmailAction;
};

type InvocationRun = RunBase & {
  event: 'invocation';
  action: InvocationAction;
};

type NoEventRun = RunBase & {
  event: 'None';
  action: 'None';
};

type RunBase = {
  hookId: number;
  hookType: HookType;
  /** @deprecated logLevel will be removed along with Logs screen removal */
  logLevel: LogLevel;
  message: string;
  queueId?: number | null;
  request: string | null;
  requestId: string;
  response: string | null;
  timestamp: string;
  start: string | null;
  end: string | null;
  status: RunStatus;
  uuid: string;
  settings?: unknown;
  cancelRequested?: string | null;
  output?: string | null;
};

export type Run =
  | AnnotationContentRun
  | AnnotationStatusRun
  | UploadRun
  | EmailRun
  | InvocationRun
  | NoEventRun;
